export default function ProgressIcon({
    style,
}) {
    return <svg style={style} width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.59961 14.5396L13.1785 19.4212L21.5469 10.3555" stroke="#4ABA72" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="14.4999" cy="14.4999" r="13.4999" fill="white" stroke="#215DAA" strokeWidth="1.5" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14.5057 27.9888C21.9584 27.9888 28.0001 21.9472 28.0001 14.4944C28.0001 7.04165 21.9584 1 14.5057 1C12.5846 1 10.7573 1.40144 9.10303 2.125C16.4543 2.24256 22.3773 8.2384 22.3773 15.6176C22.3773 21.1493 19.0489 25.9036 14.2856 27.9871C14.3588 27.9882 14.4322 27.9888 14.5057 27.9888Z" fill="#83CFA4" />
        <circle cx="14.4999" cy="14.4999" r="13.4999" stroke="#536987" strokeWidth="1.5" />
        <path d="M13.1504 6.39844V15.8484L21.2504 21.2484" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}
